export default __webpack_public_path__ + "static/media/brain-2.ba2af08b.svg";